export default __webpack_public_path__ + "static/texture2-a9c8a1167809abedd9a73f9eaa4d1574.jpg";